import React from "react";
import Skeleton from "@mui/material/Skeleton";

function VehiclePageLoader({ viewType = "grid", full = true }) {
  const count = full ? (viewType === "grid" ? 8 : 6) : 1;

  if (viewType === "list") {
    return (
      <>
        {Array.from({ length: count }).map((_, idx) => (
          <Skeleton
            key={idx}
            variant="rounded"
            width="100%"
            height={72}
            sx={{ borderRadius: "12px", mb: idx < count - 1 ? 1 : 0 }}
          />
        ))}
      </>
    );
  }

  return (
    <>
      {Array.from({ length: count }).map((_, idx) => (
        <Skeleton
          key={idx}
          variant="rounded"
          width="100%"
          height={280}
          sx={{ borderRadius: "14px" }}
        />
      ))}
    </>
  );
}

export default VehiclePageLoader;
